import React, { useState } from 'react';

const UserIdGate = ({ onSubmit }) => {
  const [userId, setUserId] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!userId.trim()) return;
    onSubmit(userId.trim());
  };

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
      <div className="card p-4 shadow" style={{ width: '400px' }}>
        <h4 className="mb-3">Enter userId</h4>
        <form onSubmit={handleSubmit}>
          <input
            className="form-control mb-3"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="userId"
          />
          <button className="btn btn-primary w-100" type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserIdGate;